import { Directive, ViewContainerRef } from '@angular/core';
    
@Directive({
  selector: '[drawerContentLoader]'
})
export class DrawerContentLoaderDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
